import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import type { ContextFamily } from '@quipex/shared/utils';
import { QpxIcon, QpxTypography, QpxTooltip } from '../../directives';
import { QpxPill } from '../pill';

export interface QpxMetadataItem {
    id: string;
    overflowOnly?: boolean;
    icon: string;
    label: string;
    value: string;
    overflowValue?: string;
    ariaLabel?: string;
    trailingIcon?: string;
    trailingIconAriaLabel?: string;
    trailingIconLabel?: string;
    trailingIconContext?: 'destructive' | 'caution' | 'success' | 'accent';
}

@Component({
    selector: 'qpx-metadata',
    imports: [QpxTooltip, NgIcon, QpxIcon, QpxPill, QpxTypography],
    templateUrl: './metadata.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'contents',
    },
})
export class QpxMetadata {
    //#region Inputs
    public readonly id = input<string>();

    public readonly icon = input.required<string>();

    public readonly label = input.required<string>();

    public readonly value = input.required<string>();

    public readonly ariaLabel = input<string>();

    public readonly trailingIcon = input<string>();

    public readonly trailingIconAriaLabel = input<string>();

    public readonly trailingIconLabel = input<string>();

    public readonly trailingIconContext = input<
        'destructive' | 'caution' | 'success' | 'accent'
    >();

    public readonly presentation = input<'inline' | 'detail'>('inline');

    //#endregion

    //#region State
    protected readonly resolvedAriaLabel = computed(() => {
        return this.ariaLabel() || `${this.label()} ${this.value()}`;
    });

    protected readonly resolvedTrailingIconContext = computed(
        (): ContextFamily => this.trailingIconContext() ?? 'secondary'
    );

    protected readonly resolvedTrailingIconLabel = computed(
        () => this.trailingIconAriaLabel() || this.trailingIconLabel() || ''
    );
    //#endregion
}
